export interface Chapter {
  num: number;
  title: string;
  updated: string;
}

export interface Manga {
  id: number;
  title: string;
  author: string;
  cover: string;
  categoryId: number;
  description: string;
  status: '连载中' | '已完结';
  latestChapter: number;
  rating: number;
  views: string;
  isHot: boolean;
  isNew: boolean;
  version: string[];
  chapters: Chapter[];
}

export interface Category {
  id: number;
  name: string;
  desc: string;
}

export const categories: Category[] = [
  { id: 1, name: '热血', desc: '燃到极致的战斗与冒险' },
  { id: 2, name: '奇幻', desc: '异世界与魔法幻想' },
  { id: 3, name: '恋爱', desc: '心动与甜蜜的日常' },
  { id: 4, name: '科幻', desc: '未来科技与星际冒险' },
  { id: 5, name: '悬疑', desc: '烧脑谜题与反转' },
  { id: 6, name: '日常', desc: '治愈温馨的生活片段' },
  { id: 7, name: '搞笑', desc: '欢乐无厘头的故事' },
  { id: 8, name: '运动', desc: '热血拼搏的竞技场' },
];

export const mangas: Manga[] = [
  {
    id: 1,
    title: '星海破晓',
    author: '朝雾一叶',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20poster%20of%20a%20determined%20young%20hero%20standing%20in%20a%20cosmic%20starry%20sky%20with%20giant%20robot%20silhouette%2C%20warm%20orange%20and%20deep%20navy%20gradient%20lighting%2C%20dynamic%20composition%2C%20clean%20bold%20linework%2C%20modern%20shounen%20anime%20art%20style%2C%20high%20detail%20character%20illustration&width=600&height=850&seq=manga-01&orientation=portrait',
    categoryId: 4,
    description:
      '少年陆遥在一次星际风暴中获得神秘机甲核心，从此踏上守护星系的征途。面对来自宇宙深处的黑暗势力，他必须与伙伴们并肩作战，在星海之中破晓黎明。这是一部充满热血与梦想的科幻巨制。',
    status: '连载中',
    latestChapter: 128,
    rating: 9.4,
    views: '238.5万',
    isHot: true,
    isNew: false,
    version: ['简体', '繁体', '双语'],
    chapters: [
      { num: 128, title: '终焉之地的约定', updated: '08-14' },
      { num: 127, title: '破碎的星图', updated: '08-12' },
      { num: 126, title: '机甲觉醒', updated: '08-09' },
      { num: 125, title: '沉默的舰队', updated: '08-06' },
      { num: 124, title: '黎明前的战役', updated: '08-03' },
    ],
  },
  {
    id: 2,
    title: '剑与苍穹',
    author: '白石川',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20poster%20of%20a%20swordsman%20holding%20a%20glowing%20katana%20on%20a%20mountain%20peak%20under%20crimson%20sky%2C%20fierce%20battle%20stance%2C%20warm%20red%20and%20gold%20cinematic%20lighting%2C%20dynamic%20action%20pose%2C%20clean%20bold%20linework%2C%20wuxia%20fantasy%20anime%20style%2C%20high%20detail&width=600&height=850&seq=manga-02&orientation=portrait',
    categoryId: 2,
    description:
      '剑客云牧一觉醒来身处陌生修真世界，背负神秘古剑却记忆全失。为寻回真相，他踏上修行之路，斩妖除魔，纵横苍穹。刀光剑影之间，一段跨越千年的宿命缓缓揭开。',
    status: '连载中',
    latestChapter: 215,
    rating: 9.6,
    views: '402.1万',
    isHot: true,
    isNew: true,
    version: ['简体', '双语'],
    chapters: [
      { num: 215, title: '万剑归宗', updated: '08-15' },
      { num: 214, title: '苍穹之巅', updated: '08-13' },
      { num: 213, title: '宿命觉醒', updated: '08-10' },
      { num: 212, title: '古剑异变', updated: '08-07' },
      { num: 211, title: '血月之夜', updated: '08-04' },
    ],
  },
  {
    id: 3,
    title: '心跳补习班',
    author: '春野柚子',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20poster%20of%20a%20sweet%20romance%20scene%20between%20a%20boy%20and%20girl%20in%20a%20sunlit%20school%20classroom%2C%20cherry%20blossom%20petals%20floating%2C%20soft%20pink%20and%20warm%20cream%20tones%2C%20gentle%20romantic%20mood%2C%20clean%20anime%20art%20style%2C%20high%20detail%20illustration&width=600&height=850&seq=manga-03&orientation=portrait',
    categoryId: 3,
    description:
      '学霸千夏被迫给笨拙的同桌补习，从最初的针锋相对，到渐渐心动。在一次次的课后补习中，两颗心慢慢靠近。甜蜜爆棚的校园恋爱轻喜剧，让你心跳加速。',
    status: '连载中',
    latestChapter: 86,
    rating: 8.9,
    views: '156.3万',
    isHot: true,
    isNew: false,
    version: ['简体', '繁体', '双语'],
    chapters: [
      { num: 86, title: '夏日的告白', updated: '08-14' },
      { num: 85, title: '同桌的守护', updated: '08-11' },
      { num: 84, title: '心跳加速时', updated: '08-08' },
      { num: 83, title: '雨中的约定', updated: '08-05' },
      { num: 82, title: '补习班日常', updated: '08-02' },
    ],
  },
  {
    id: 4,
    title: '鬼影侦探社',
    author: '雾岛夜行',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20poster%20of%20a%20mysterious%20detective%20in%20a%20trench%20coat%20holding%20a%20magnifying%20glass%20in%20a%20foggy%20noir%20city%20at%20night%2C%20eerie%20green%20and%20dark%20teal%20lighting%2C%20mysterious%20supernatural%20atmosphere%2C%20clean%20bold%20linework%2C%20horror%20mystery%20anime%20style%2C%20high%20detail&width=600&height=850&seq=manga-04&orientation=portrait',
    categoryId: 5,
    description:
      '霓虹都市之下隐藏着无数灵异事件，冷峻侦探与神秘少女搭档，抽丝剥茧追查案件真相。每一个案子背后都藏着令人脊背发凉的秘密，反转不断，烧脑至极。',
    status: '连载中',
    latestChapter: 64,
    rating: 9.1,
    views: '98.7万',
    isHot: false,
    isNew: true,
    version: ['简体', '双语'],
    chapters: [
      { num: 64, title: '消失的影', updated: '08-13' },
      { num: 63, title: '雾中谜局', updated: '08-10' },
      { num: 62, title: '鬼影重现', updated: '08-07' },
      { num: 61, title: '深夜来电', updated: '08-04' },
      { num: 60, title: '第零号案件', updated: '08-01' },
    ],
  },
  {
    id: 5,
    title: '云端咖啡屋',
    author: '南泽日和',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20poster%20of%20a%20cozy%20cafe%20scene%20with%20a%20barista%20serving%20coffee%20and%20pastries%20by%20a%20large%20window%20with%20warm%20sunlight%2C%20soft%20beige%20and%20warm%20brown%20tones%2C%20relaxing%20healing%20atmosphere%2C%20clean%20anime%20art%20style%2C%20high%20detail%20illustration&width=600&height=850&seq=manga-05&orientation=portrait',
    categoryId: 6,
    description:
      '在云层之上的天空咖啡屋，店主佑真为每位客人亲手冲泡治愈的咖啡。来这里倾诉烦恼的客人，都能找到属于自己的那一杯温暖。温柔治愈的日常单元剧，抚慰每一颗疲惫的心。',
    status: '已完结',
    latestChapter: 72,
    rating: 9.2,
    views: '132.9万',
    isHot: false,
    isNew: false,
    version: ['简体', '繁体'],
    chapters: [
      { num: 72, title: '最后的告别', updated: '08-12' },
      { num: 71, title: '云上的约定', updated: '08-09' },
      { num: 70, title: '一杯热拿铁', updated: '08-06' },
      { num: 69, title: '雨天的客人', updated: '08-03' },
      { num: 68, title: '初见的味道', updated: '08-01' },
    ],
  },
  {
    id: 6,
    title: '爆笑食堂',
    author: '笑面虎',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20poster%20of%20a%20funny%20chef%20throwing%20frying%20pans%20in%20a%20chaotic%20colorful%20kitchen%2C%20comedy%20exaggerated%20expressions%2C%20bright%20warm%20yellow%20and%20red%20colors%2C%20playful%20humorous%20mood%2C%20clean%20bold%20anime%20style%2C%20high%20detail&width=600&height=850&seq=manga-06&orientation=portrait',
    categoryId: 7,
    description:
      '美食与搞笑的双重盛宴！厨艺高超却总是搞砸的天才厨师，每次下厨都是一场灾难现场。笑点密集、无厘头爆棚的日常喜剧，让你笑到停不下来。',
    status: '连载中',
    latestChapter: 154,
    rating: 8.7,
    views: '210.4万',
    isHot: true,
    isNew: false,
    version: ['简体', '双语'],
    chapters: [
      { num: 154, title: '咖喱大作战', updated: '08-14' },
      { num: 153, title: '甜品对决', updated: '08-11' },
      { num: 152, title: '黑暗料理王', updated: '08-08' },
      { num: 151, title: '火锅风波', updated: '08-05' },
      { num: 150, title: '神秘试菜员', updated: '08-02' },
    ],
  },
  {
    id: 7,
    title: '烈焰高中',
    author: '赤木刚宪',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20poster%20of%20a%20basketball%20player%20dunking%20a%20ball%20in%20a%20fiery%20indoor%20court%2C%20sweat%20and%20determination%2C%20warm%20orange%20and%20flame%20red%20dramatic%20lighting%2C%20dynamic%20sports%20action%2C%20clean%20bold%20anime%20style%2C%20high%20detail&width=600&height=850&seq=manga-07&orientation=portrait',
    categoryId: 8,
    description:
      '曾经没落的烈火高中篮球队，迎来了一位天赋异禀却问题重重的少年。在一次次的失利与汗水之中，他们燃烧青春，向全国大赛发起冲击。热血运动番巅峰之作。',
    status: '连载中',
    latestChapter: 96,
    rating: 9.5,
    views: '345.8万',
    isHot: true,
    isNew: true,
    version: ['简体', '繁体', '双语'],
    chapters: [
      { num: 96, title: '决战之巅', updated: '08-15' },
      { num: 95, title: '王者归来', updated: '08-13' },
      { num: 94, title: '最后一攻', updated: '08-10' },
      { num: 93, title: '逆风翻盘', updated: '08-07' },
      { num: 92, title: '火焰对决', updated: '08-04' },
    ],
  },
  {
    id: 8,
    title: '炼金术士日常',
    author: '银之匙',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20poster%20of%20a%20young%20alchemist%20in%20a%20magical%20workshop%20surrounded%20by%20glowing%20potions%20and%20spell%20circles%2C%20warm%20amber%20and%20teal%20magical%20glow%2C%20whimsical%20fantasy%20mood%2C%20clean%20bold%20anime%20style%2C%20high%20detail%20illustration&width=600&height=850&seq=manga-08&orientation=portrait',
    categoryId: 2,
    description:
      '在魔法与炼金术并存的大陆，梦想成为传奇炼金术士的少年与他的会说话的猫搭档，一边搞笑一边炼金。轻松诙谐的奇幻冒险，充满想象力的药剂世界。',
    status: '连载中',
    latestChapter: 43,
    rating: 8.8,
    views: '76.2万',
    isHot: false,
    isNew: true,
    version: ['简体', '双语'],
    chapters: [
      { num: 43, title: '贤者之石', updated: '08-13' },
      { num: 42, title: '神奇药剂', updated: '08-10' },
      { num: 41, title: '会说话的猫', updated: '08-07' },
      { num: 40, title: '魔法工坊', updated: '08-04' },
      { num: 39, title: '初试炼金', updated: '08-01' },
    ],
  },
  {
    id: 9,
    title: '失忆恋人',
    author: '森岛千寻',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20poster%20of%20a%20tender%20romantic%20scene%20of%20two%20lovers%20under%20a%20starry%20night%20sky%20in%20a%20quiet%20park%2C%20soft%20warm%20pastel%20tones%2C%20emotional%20melancholic%20romantic%20mood%2C%20clean%20anime%20art%20style%2C%20high%20detail%20illustration&width=600&height=850&seq=manga-09&orientation=portrait',
    categoryId: 3,
    description:
      '女主醒来后失去了与恋人有关的所有记忆，而那个深爱着她的少年选择默默守护。在一次次重逢与回忆碎片之中，一场跨越遗忘的深情恋曲缓缓奏响。催泪治愈系恋爱故事。',
    status: '已完结',
    latestChapter: 58,
    rating: 9.0,
    views: '118.6万',
    isHot: false,
    isNew: false,
    version: ['简体', '繁体', '双语'],
    chapters: [
      { num: 58, title: '终章·记得你', updated: '08-11' },
      { num: 57, title: '回忆之海', updated: '08-08' },
      { num: 56, title: '失而复得', updated: '08-05' },
      { num: 55, title: '星空下的承诺', updated: '08-02' },
      { num: 54, title: '遗忘的开始', updated: '07-30' },
    ],
  },
  {
    id: 10,
    title: '机械王国',
    author: '铁心工房',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20poster%20of%20a%20futuristic%20mech%20city%20with%20a%20humanoid%20robot%20warrior%20in%20the%20foreground%2C%20warm%20orange%20and%20steel%20gray%20industrial%20lighting%2C%20mecha%20sci-fi%20anime%20style%2C%20clean%20bold%20linework%2C%20high%20detail%2C%20epic%20scale&width=600&height=850&seq=manga-10&orientation=portrait',
    categoryId: 4,
    description:
      '人类与机械共存的蒸汽朋克都市，人形机甲战士与年轻的机械师搭档，对抗失控的机械军团。废土美学与硬核机战完美结合，燃爆天际。',
    status: '连载中',
    latestChapter: 109,
    rating: 9.3,
    views: '187.4万',
    isHot: false,
    isNew: false,
    version: ['简体', '双语'],
    chapters: [
      { num: 109, title: '钢铁意志', updated: '08-12' },
      { num: 108, title: '失控军团', updated: '08-09' },
      { num: 107, title: '核心觉醒', updated: '08-06' },
      { num: 106, title: '废土重生', updated: '08-03' },
      { num: 105, title: '最后的防线', updated: '08-01' },
    ],
  },
  {
    id: 11,
    title: '元气满满的日常',
    author: '向日葵',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20poster%20of%20a%20group%20of%20happy%20teenage%20friends%20laughing%20in%20a%20sunny%20school%20courtyard%2C%20warm%20bright%20yellow%20and%20cream%20tones%2C%20cheerful%20energetic%20slice%20of%20life%20mood%2C%20clean%20anime%20art%20style%2C%20high%20detail%20illustration&width=600&height=850&seq=manga-11&orientation=portrait',
    categoryId: 6,
    description:
      '元气少女小葵和她的小伙伴们的爆笑校园日常！上课、社团、祭典，每一天都充满活力与欢乐。轻松治愈的单元式日常番，让人忍不住嘴角上扬。',
    status: '连载中',
    latestChapter: 132,
    rating: 8.6,
    views: '143.7万',
    isHot: true,
    isNew: false,
    version: ['简体', '繁体'],
    chapters: [
      { num: 132, title: '夏日祭典', updated: '08-14' },
      { num: 131, title: '社团大作战', updated: '08-11' },
      { num: 130, title: '元气满满', updated: '08-08' },
      { num: 129, title: '课堂风波', updated: '08-05' },
      { num: 128, title: '青春日常', updated: '08-02' },
    ],
  },
  {
    id: 12,
    title: '暗夜法则',
    author: '黑之瞳',
    cover: 'https://readdy.ai/api/search-image?query=anime%20manga%20poster%20of%20a%20mysterious%20anti-hero%20in%20a%20dark%20alley%20with%20glowing%20red%20eyes%2C%20rainy%20noir%20night%20scene%2C%20dark%20crimson%20and%20charcoal%20tones%2C%20tense%20suspenseful%20mood%2C%20clean%20bold%20anime%20style%2C%20high%20detail%20illustration&width=600&height=850&seq=manga-12&orientation=portrait',
    categoryId: 5,
    description:
      '在这座由地下势力统治的城市，代号"夜枭"的神秘执行者游走于黑暗之中，用铁腕手段维持着脆弱的秩序。悬疑感拉满的都市暗黑群像剧，每一步都暗藏杀机。',
    status: '连载中',
    latestChapter: 51,
    rating: 9.1,
    views: '89.3万',
    isHot: false,
    isNew: true,
    version: ['简体', '双语'],
    chapters: [
      { num: 51, title: '暗夜裁决', updated: '08-13' },
      { num: 50, title: '血色交易', updated: '08-10' },
      { num: 49, title: '夜枭现身', updated: '08-07' },
      { num: 48, title: '城邦迷局', updated: '08-04' },
      { num: 47, title: '暗流涌动', updated: '08-01' },
    ],
  },
];